<template>
  <div>
    <ImageZoom v-if="type === 'image'" :src="src" :height="height" />
    <iframe
      v-else-if="type === 'pdf'"
      :src="src"
      :height="height"
      width="100%"
      :style="{ minHeight: height }"
    />
  </div>
</template>

<script>
import ImageZoom from "@/components/global/ImageZoom.vue";

export default {
  name: "ConcessionDocumentViewer",
  components: {
    ImageZoom,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    height: {
      type: String,
    },
  },
  computed: {
    type() {
      return this.src.includes(".pdf") ? "pdf" : "image";
    },
  },
};
</script>
